import React from 'react'
import { Checkout } from '../features/checkout/components/Checkout'
import {Footer} from '../features/footer/Footer'

export const CheckoutPage = () => {
  return (
    <>
    <Checkout/>
    <Footer/>
    </>
  )
}
